import { render, staticRenderFns } from "./AwarenessDaysCalendar.vue?vue&type=template&id=7ac4ca08&scoped=true&"
import script from "./AwarenessDaysCalendar.vue?vue&type=script&lang=js&"
export * from "./AwarenessDaysCalendar.vue?vue&type=script&lang=js&"
import style0 from "./AwarenessDaysCalendar.vue?vue&type=style&index=0&id=7ac4ca08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac4ca08",
  null
  
)

export default component.exports